/* eslint-disable @typescript-eslint/no-explicit-any */
import { Button, Group, Modal, Select, Text, TextInput } from "@mantine/core";
import { generateClient, GraphQLQuery, put } from "aws-amplify/api";
import {
  fetchAuthSession,
  getCurrentUser,
  GetCurrentUserOutput
} from "aws-amplify/auth";
import { useEffect, useState } from "react";
import {
  UpdateTemplateSubsectionInput,
  UpdateTemplateSubsectionMutation,
  UpdateTemplateSubsectionMutationVariables
} from "../../../API";
import { updateTemplateSubsection } from "../../../graphql/mutations";
import ConfirmDeleteModal from "./ConfirmDeleteModal";
const client = generateClient();

type editSubSectionTemplateProps = {
  modalOpened: boolean;
  setModalOpened: (value: boolean) => void;
  template: any;
  fetchTemplate: (templateId: string) => void;
  subsection: any;
};

const EditSubSectionTemplateModal = (props: editSubSectionTemplateProps) => {
  const { modalOpened, setModalOpened, fetchTemplate, template, subsection } =
    props;
  const [errorMsg, setErrorMsg] = useState("");
  const [subsectionName, setSubsectionName] = useState("");
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [modalDeleteOpened, setModalDeleteOpened] = useState<boolean>(false);
  const [sections, setSections] = useState();
  const [sectionId, setSectionId] = useState<any>();
  useEffect(() => {
    if (!template?.sections) {
      return;
    }
    const initSections = template.sections.items
      .filter(
        (section: any) =>
          section.isSimple === false || section.isSimple === null
      )
      ?.map((section: any) => {
        return { value: section.id, label: section.name };
      });
    if (initSections && initSections.length > 0) {
      setSections(initSections);
      setSectionId(initSections[0].value);
    }
  }, [template]);
  useEffect(() => {
    console.log({ subsection });

    if (subsection) {
      setSubsectionName(subsection.name);
      setSectionId(subsection.sID);
    }
  }, [subsection]);

  const handleEditSubSection = async () => {
    if (subsectionName?.trim() == "" || sectionId == "") {
      setErrorMsg("Please provide both subsection name and section");
      return;
    }
    setErrorMsg("");
    setIsLoading(true);
    try {
      const updateSubsectionInput: UpdateTemplateSubsectionInput = {
        id: subsection.id,
        _version: subsection._version,
        name: subsectionName,
        sID: sectionId
      };

      const updateSubsectionInputVars: UpdateTemplateSubsectionMutationVariables =
        {
          input: updateSubsectionInput
        };

      const updateSubsectionResponse = await client.graphql<
        GraphQLQuery<UpdateTemplateSubsectionMutation>
      >({
        query: updateTemplateSubsection,
        variables: updateSubsectionInputVars
      });
      console.log(updateSubsectionResponse);
      setIsLoading(false);
      fetchTemplate(template.id);
      closeAndResetModal();
    } catch (err) {
      console.log("error creating sub section:", err);
      setIsLoading(false);
    }
  };
  const handleDeleteSubsection = () => {
    setModalOpened(false);
    // if (subsection?.fields?.items?.length > 0) {
    //   appShowNotification({
    //     title:
    //       "Please move or delete all subsection fields before deleting this subsection",
    //     type: "warning"
    //   });
    //   return;
    // }
    setModalDeleteOpened(true);
  };
  const deleteSubsectionRequest = async () => {
    setIsLoading(true);
    const user: GetCurrentUserOutput = await getCurrentUser();
    const { identityId } = await fetchAuthSession();

    console.log("user: ", user);
    const init: any = {
      response: true,
      headers: {},
      body: {
        templateSubsection: subsection,
        username: user.username,
        userIdentityId: identityId
      }
    };
    try {
      const deleteTemplateSubsectionResult = put({
        apiName: "DeleteTemplateSubsection",
        path: `/templatesubsection/${subsection.id}`,
        options: init
      });
      console.log(
        "deleteTemplateSubsection success: ",
        await deleteTemplateSubsectionResult.response
      );
    } catch (err) {
      console.log("deleteTemplateSubsection error: ", err);
    }
    fetchTemplate(template.id);
    setIsLoading(false);
    closeAndResetModal();
  };
  const closeAndResetModal = () => {
    setModalOpened(false);
    setModalDeleteOpened(false);
    setErrorMsg("");
  };
  return (
    <>
      <Modal
        opened={modalOpened}
        onClose={closeAndResetModal}
        title="Edit subsection"
      >
        <TextInput
          label="Name"
          placeholder="Enter template subsection"
          value={subsectionName}
          onChange={(event) => setSubsectionName(event.target.value)}
          required
        />
        {errorMsg && (
          <Text fz={14} fw={400} c={"red"}>
            {errorMsg}
          </Text>
        )}
        <Select
          placeholder="Select section"
          label="Section"
          data={sections}
          value={sectionId}
          onChange={(_value, option) => setSectionId(option.value)}
        />

        <Group mt="md">
          <Group mt="md">
            <Button
              disabled={isLoading}
              loading={isLoading}
              onClick={handleEditSubSection}
            >
              Save
            </Button>
            <Button
              disabled={isLoading}
              color="red"
              loading={isLoading}
              onClick={handleDeleteSubsection}
            >
              Delete
            </Button>
          </Group>
        </Group>
      </Modal>
      <ConfirmDeleteModal
        modalOpened={modalDeleteOpened}
        title={"Delete subsection"}
        body={"Are you sure you want to delete this subsection?"}
        setModalOpened={setModalDeleteOpened}
        onDelete={deleteSubsectionRequest}
      />
    </>
  );
};
export default EditSubSectionTemplateModal;
